<template>
<div>
  <b-dropdown variant="link" no-caret>
    <template slot="button-content"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></template>
    <b-dropdown-item-button @click="deleteLote(data.id)" v-if="canDelete()">Eliminar Lote</b-dropdown-item-button>
    <b-dropdown-item-button @click="editLote(data.id)" v-if="canDelete()">Modificar Lote</b-dropdown-item-button>
    <b-dropdown-item-button @click="gestionarLote" v-if="canGestionar()">Gestionar Lote</b-dropdown-item-button>
    <b-dropdown-item-button @click="cerrarLote" v-if="canCerrar()">Cerrar Lote</b-dropdown-item-button>
    <b-dropdown-item-button @click="getLote" v-if="hasPermision('C') || hasPermision('A')">Ver Lote</b-dropdown-item-button>
    <b-dropdown-item-button @click="exportarLote" v-if="hasPermision('X')">Exportar Lote</b-dropdown-item-button>
  </b-dropdown>
</div>
</template>

<script>
export default {
  name: 'Actions',
  props: ['data'],
  methods: {
    exportarLote: function () {
      this.$http.get('asignacion_lote/', {params: {id_lote: this.data.id, not_paginated: true}}).then(result => {
        var type = (this.data.tipo_lote === 'GC') ? 'comercial' : 'caldera';
        var list = result.data.map(e => e['id_' + type]);
        list = list.join(',');
        var q = '';
        if (type === 'comercial') {
          q = 'c.id_comercial';
        } else {
          q = 'cent.id_caldera';
        }
        q = q + ' IN (' + list + ')';
        var path = {name: 'Download'};
        if (Object.keys(q).length) {
          path['query'] = {'q': q, 'type': type, 'lote': this.data.id};
          if (this.hasPermision('A')) {
            path['query']['user'] = true;
          }
        }
        let routeData = this.$router.resolve(path);
        window.open(routeData.href, '_blank');
      });
    },
    hasPermision: function (p) {
      return this.$parent.$parent.$parent.$parent.$parent.hasPermision({rol: 'GESTION COMERCIAL'}, p);
    },
    deleteLote (id) {
      this.$parent.$parent.$parent.$parent.$parent.preventDelete(id);
    },
    editLote (id) {
      this.$parent.$parent.$parent.$parent.$parent.editLote(id);
    },
    getLote () {
      this.$parent.$parent.$parent.$parent.$parent.getLote(this.data.id);
    },
    gestionarLote () {
      this.$parent.$parent.$parent.$parent.$parent.gestionarLote(this.data);
    },
    cerrarLote () {
      this.$parent.$parent.$parent.$parent.$parent.cerrarLote(this.data.id);
    },
    canDelete () {
      if (this.hasPermision('A')) {
        return false;
      }
      if (this.data.status.toLocaleLowerCase() === 'creado') {
        return this.hasPermision('E');
      }
      return false;
    },
    canGestionar () {
      if (this.data.status !== 'Cerrado') {
        return this.hasPermision('E') || this.hasPermision('A');
      }
      return false;
    },
    canCerrar () {
      // if (this.hasPermision('A')) {
      //   return false
      // }
      if (this.data.status !== 'Cerrado') {
        return this.hasPermision('E') || this.hasPermision('A');
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/LotesTableActions.vue